module.exports = __webpack_public_path__ + "img/total_value.b768461f.svg";